import React, { useEffect } from 'react'
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import Home from '../Pages/Home';

const MainNavigator = () => {
    useEffect(() => {
        const metaThemeColor = document.querySelector("meta[name='theme-color']");
        if (metaThemeColor) {
            metaThemeColor.setAttribute("content", "#ECFAFF");
        } else {
            const meta = document.createElement("meta");
            meta.name = "theme-color";
            meta.content = "#ECFAFF";
            document.head.appendChild(meta);
        }
    }, []);

    return (
        <div>
            <ToastContainer />
            <Routes>
                <Route path="*" element={<Home />}></Route>
                <Route path="/" element={<Home />}></Route>
                <Route path="/:eventIdentifier" element={<Home />}></Route>
            </Routes>
        </div>
    )
}

export default MainNavigator